<div class="h-100 w-100" fxLayout="column">
    <div fxLayout="row" class="main-bc header" ngClass.desktop="pl-20 pr-20" ngClass.mobile="pl-16 pr-16 header"
         fxLayoutAlign="space-between center">
        <ui-kit-svg class="header-logo" name="header-logo"></ui-kit-svg>
        <ui-kit-language-toggle class="ml-32"></ui-kit-language-toggle>
    </div>

    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutAlign.mobile="flex-start center" class="h-100 root-container">
        <div class="container" fxLayout="column" fxFlex.desktop>
            <div class="content" fxLayoutAlign.desktop="start center" fxFlex.desktop>
                <router-outlet></router-outlet>
            </div>
        </div>

        @if (showCancelButton()) {
            <ui-kit-button class="mt-16 mb-16"
                           (clickListener)="cancel()"
                           type="text"
                           spinnerId="cancel"
                           [label]="'i18n_auth_buttonCancel' | translate"/>
        }
    </div>
</div>
